import { Link } from "react-router-dom";

const MMS = () => {
    return (
       
        <div>
            
            <div className="flex flex-col justify-center items-center ">
            <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
            <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
                    
                    <div className="flex flex-col justify-center">
                        <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                            Mailroom Management
                        </h1>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                            As Pakistan’s first and the fastest digital transactional printing facility, TCS offers end-to-end 
                            Mailroom Management Solutions (MMS) and Managed Printing Services (MPS), covering all aspects 
                            of printing and bulk distribution from designing and variable data printing, to auto-insertion, 
                            procurement, mailroom management, normal bulk shipment distribution, confirmation circulars 
                            delivery service, CNIC expiry info circular, debit/credit card delivery, CNIC delivery 
                            services and more.
                        </p>

                <div className=" mt-[1rem] w-[100%]">
                        
                        <div className="flex justify-left">
                            <Link to="/mms" className="flex justify-center text-center rounded-sm items-center h-9 mt-[2px] text-white bg-[#D40511] border border-[#F21E26] w-[10rem] rounded-md mt-[1rem] p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">Find Out More</Link>
                           
                        </div>
                </div>
                    </div>
                    
                    <div className="flex-1 flex flex-col justify-center items-center">
                        <img src="/DomesticScrollingBanner/image18.jpg" alt="" className="rounded-md max-w-[100%] sm:mt-[0rem] mt-[1rem]"/>
                    </div>
                </div>
               
               
      
            </div>
            
        </div>
        
    )
};
export default MMS;